import api from '../../utils/axios';

export const placesService = {
  getAutocomplete: async (input, sessionToken) => {
    if (!input || input.trim().length < 3) {
      return { status: true, suggestions: [] };
    }
    const response = await api.get('/places/autocomplete', {
      params: { input: input.trim(), sessionToken }
    });
    return response.data;
  },

  getPlaceDetails: async (placeId, sessionToken) => {
    if (!placeId) return null;
    const response = await api.get('/places/details', {
      params: { placeId, sessionToken }
    });
    return response.data;
  }
};

export default placesService;
